/// <reference types="./i18n.d.mts" />
export function pluralize(word, count) {
  let $ = count > 1;
  if ($) {
    return word + "s";
  } else {
    return word;
  }
}
